import { useState } from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { ReturnTranslatedText } from '@wajeez-web/core/localization';
import { useCommonSelector } from '@wajeez-web/stores/common';

type DropdownItem = {
  label: string;
  onClick: () => void;
  Icon?: React.ReactElement;
};

interface DropdownProps {
  id: string;
  label: string | React.ReactElement;
  items: (DropdownItem | null | undefined)[];
  buttonStyle?: { [key: string]: string };
}

export const Dropdown = ({ id, label, items, buttonStyle }: DropdownProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const dir = useCommonSelector(({ common }) => common.settings.dir);

  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const renderItems = () => {
    return items.map((i) => {
      if (i) {
        const { label, onClick, Icon } = i;

        return (
          <MenuItem
            key={label}
            onClick={() => {
              onClick();

              handleClose();
            }}
          >
            <div
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'center',
                fontFamily: 'Tajawal',
              }}
            >
              <div
                style={{
                  marginLeft: dir === 'rtl' ? '4px' : '0',
                  marginRight: dir === 'rtl' ? '0' : '4px',
                }}
              >
                {Icon}
              </div>
              <div>
                <ReturnTranslatedText
                  origintext={label}
                  text={`dropdowns.lists.${label}`}
                />
              </div>
            </div>
          </MenuItem>
        );
      } else {
        return null;
      }
    });
  };

  return (
    <div>
      <Button
        id={`button-${id}`}
        aria-controls={open ? `menu-${id}` : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        sx={{
          height: '27px',
          fontFamily: 'Tajawal',
          border: '1px solid #ced4da',
          ...buttonStyle,
        }}
      >
        {label}
      </Button>
      <Menu
        id={`menu-${id}`}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': `button-${id}`,
        }}
      >
        {renderItems()}
      </Menu>
    </div>
  );
};
